export class UpdateReservationPhoneNumberUnexpectedTransactionsError extends Error {
  static create(errorMessage) {
    return new UpdateReservationPhoneNumberUnexpectedTransactionsError(errorMessage)
  }
}
